<template>
  <!-- 加载遮罩 -->
  <div class="loading-mask" v-if="showLoading">
    <img src="@/assets/load.png" alt="加载中" class="loading-img" />
  </div>
  <div class="login-page">
  <div class="login-btns">
    <!-- 顶部全宽按钮 -->
    <div class="btn-double" @click="registHandler('st')">
      <img src="@/assets/double.png" alt="会议/参观注册" />
    </div>
    <!-- 两列布局 -->
    <div class="two-col-row">
      <div class="big-btn btn-visitor" @click="registHandler('gz')">
        <img src="@/assets/visitor.png" alt="参观注册" />
      </div>
      <div class="big-btn btn-richeng" @click="goSchedule">
        <img src="@/assets/richeng.png" alt="大会日程" />
      </div>
    </div>
    <div class="two-col-row">
      <div class="big-btn btn-gw" @click="linkHander('gw')">
        <img src="@/assets/gw.png" alt="官网" />
      </div>
      <div class="big-btn btn-hezuo" @click="registHandler('hz')">
        <img src="@/assets/hezuo.png" alt="我要合作" />
      </div>
    </div>
    <!-- 三列带竖线分隔 -->
    <div class="three-col-row">
      <div class="col-item" @click="showComingSoon">
        <img src="@/assets/tpzb.png" alt="图片直播" />
      </div>
      <img src="@/assets/jiange.png" alt="" class="separator" />
      <div class="col-item" @click="showComingSoon">
        <img src="@/assets/spzb.png" alt="视频直播" />
      </div>
      <img src="@/assets/jiange.png" alt="" class="separator" />
      <div class="col-item" @click="registHandler('lg')">
        <img src="@/assets/center.png" alt="个人中心" />
      </div>
    </div>
    <!-- 底部全宽按钮 -->
    <div class="big-btnqn fullqn" @click="linkHander('qnlm')">
      <img src="@/assets/qnlm.png" alt="申请加入氢能联盟" />
    </div>
    <div class="btn-link" style="margin-top: 4vw">
      <img src="@/assets/link.png" alt="" />
    </div>
  </div>
  <!-- 手机号验证 -->
  <div class="minDia" v-if="showRegMobile">
    <div>
      <!-- <div class="login" v-show="(isWeX && openid) || !isWeX"> -->
      <div class="login">
        
        <h3 class="exhName"></h3>
        <div class="logins">
          <img class="closeRegMobile" src="@/assets/close.png" @click="showRegMobile = false" alt="关闭" />
          <h2 class="loginTit">手机号验证<br /><span class="loginTit-en">Mobile Number Verification</span></h2>
          <div class="loginFormbox">
            <van-form ref="loginForm" @submit="onSubmit">
              <div class="formItem">
                <van-field
                  v-model="form.mobile"
                  name="mobile"
                  placeholder="请输入手机号"
                  :rules="[
                    {
                      required: true,
                      validator: validatorMobile,
                      message: '请输入正确的手机号'
                    }
                  ]"
                >
                  <template #label>
                    <span>手机号</span>
                    <span class="label-en">Mobile Number</span>
                  </template>
                </van-field>
              </div>
              <div class="formItem">
                <van-cell-group>
                  <van-field
                    v-model="form.code"
                    center
                    clearable
                    name="code"
                    placeholder="请输入短信验证码"
                    maxlength="4"
                    :rules="[
                      {
                        required: true,
                        validator: validatorCode,
                        message: '请输入正确的短信验证码'
                      }
                    ]"
                  >
                    <template #label>
                      <span>短信验证码</span>
                      <span class="label-en">SMS Verification Code</span>
                    </template>
                    <template #button>
                      <van-button
                        style="width: 100%; height: 42px; border-radius: 0 6px 6px 0"
                        :disabled="btnTxt !== '发送验证码'"
                        color="#53a7fd"
                        @click="getSms"
                        size="small"
                        type="primary"
                        >
                        <span style="color: #fff">{{ btnTxt }}</span>
                        <br v-if="btnTxt === '发送验证码'" />
                        <span v-if="btnTxt === '发送验证码'" class="btn-en" style="color: #fff">Send Code</span>
                      </van-button>
                    </template>
                  </van-field>
                </van-cell-group>
              </div>
              <div
                :class="
                  gconfig.MobilePageBottomText ? 'btnbox' : 'btnbox pad40'
                "
              >
                <van-button
                  type="primary"
                  color="#003df2"
                  native-type="submit"
                >
                  注册/登陆
                  <br />
                  <span class="btn-en">Register/Login</span>
                </van-button>
              </div>
              <div v-html="gconfig.MobilePageBottomText"></div>
            </van-form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="minDia" v-if="showTip">
    <div class="diaCon">
      <div class="tipTxt" v-html="gconfig.HomePagePop"></div>
      <div class="tipBtn">
        <van-button
          type="primary"
          :color="mainColor"
          size="small"
          round
          @click="showTip = false"
          >确认</van-button
        >
      </div>
    </div>
  </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api/index.js'
import { showLoadingToast, showToast, showFailToast } from 'vant'
import { regMobile } from '@/utils/regs.js'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'

// sessionStorage.clear()
const store = useStore()
const router = useRouter()
const route = useRoute()
// 保存入口路径
sessionStorage.setItem('enterPath', route.path)
if (route.query.source) {
  sessionStorage.setItem('source', route.query.source)
}
// 邀请参数
if (route.query.invitesource) {
  sessionStorage.setItem('invitesource', route.query.invitesource)
}
if (route.query.invitesourceID) {
  sessionStorage.setItem('invitesourceID', route.query.invitesourceID)
}
if (route.query.lan) {
  sessionStorage.setItem('lan', route.query.lan)
}
if (route.query.ExhCode) {
  store.commit('setExhCode', route.query.ExhCode)
} else {
  showFailToast('展会参数缺失！')
}
const openid = computed(() => store.state.openid)
const isWeX = computed(() => store.state.isWeX)
const VisitorID = computed(() => store.state.VisitorID)
const ExhCode = computed(() => {
  return store.state.ExhCode
})
const mainColor = computed(() => store.state.mainColor)

// 加载状态
const showLoading = ref(true)

const showRegMobile = ref(false)
const registType = ref('')
const registHandler = (type) => {
  if (VisitorID.value) {
    router.push({ path: '/success', query: { regType: type } })
  } else {
    showRegMobile.value = true
    registType.value = type
  }
}
const linkHander = (type) => {
  if (type === 'gw') {
    window.location.href = 'https://www.cihcexpo.com/'
  }
  if (type === 'qnlm') {
    window.location.href = 'https://www.wjx.top/vm/mB53hKQ.aspx'
  }
}
const goSchedule = () => {
  router.push({ path: '/schedule' })
}
const showComingSoon = () => {
  showToast({
    message: '敬请期待 Coming Soon \n 2026-03-25',
    position: 'middle',
    className: 'custom-toast'
  })
}
const form = ref({
  code: '',
  mobile: ''
})
// 校验手机号
const validatorMobile = (val) => {
  return regMobile.test(val)
}
// 校验验证码格式
const regCode = /^[0-9]{4}$/
const validatorCode = (val) => {
  return regCode.test(val)
}
const loginForm = ref()
// 登录
const onSubmit = () => {
  loginForm.value.validate().then((valid) => {
    if (!valid) {
      api
        .checkMobileLoginApi({
          mobile: form.value.mobile,
          smscode: form.value.code,
          ExhCode: ExhCode.value,
          OpenID: openid.value
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              // 邮箱已注册
              if (res.data.visitorID) {
                store.commit('setVisitorID', res.data.visitorID)
                sessionStorage.setItem('invitesourceID', res.data.visitorID)
                if (gconfig.value.SuccessPageVersion === 'V2') {
                  router.push({ path: '/successV2' })
                } else {
                  router.push({ path: '/success' })
                }
              }
            } else {
              if (registType.value === 'lg') {
                // 个人中心仅提示未注册
                showFailToast('手机号未注册！')
              } else {
                store.commit('setLoginForm', form.value)
                router.push({
                  path: '/msg',
                  query: { regType: registType.value }
                })
              }
            }
          }
        })
    }
  })
}
onMounted(() => {
  // 3秒后隐藏加载遮罩
  setTimeout(() => {
    showLoading.value = false
  }, 3000)  
  getToken()
})
const token = computed(() => {
  return store.state.token
})
const getToken = async () => {
  const res = await api.getTokenApi()
  store.commit('setToken', res.data.authorToken)
  getOpenID()
  getGlobalConfig()
}
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}

const getGlobalConfig = async () => {
  const res = await api.getGConfig({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    const tmpObj = {}
    const resObj = JSON.parse(decryptionECB(res.data.configuartion))
    console.log(resObj, 'fffffffff')
    resObj.forEach((item) => {
      tmpObj[item.GlobalKey] = item.GlobalValue
    })
    store.commit('setGConfig', res.data.configuartion)
    store.commit('setMainColor', tmpObj.ButtonColor)
    // 判断展会是否关闭
    closeRes(gconfig.value.RegistStopTime)
    // closeRes('2023-02-04 14:00:00')
    if (isWeX.value) {
      wx.getWXSign()
    }
  }
}
// 显示配置提示弹窗
let hasPop = false
if (gconfig.value.HomePagePop) {
  hasPop = true
} else {
  hasPop = false
}
const showTip = ref(hasPop)
const isClose = ref(false)
const closeRes = (str) => {
  const val = str.replace(/-/g, '/')
  isClose.value = new Date().getTime() >= new Date(val).getTime()
}
const timer = ref(null)
const downTime = (time) => {
  timer.value = setInterval(() => {
    if (time > 0) {
      time--
      btnTxt.value = `${time}s`
    } else {
      btnTxt.value = '发送验证码'
      clearInterval(timer.value)
    }
  }, 1000)
}
const btnTxt = ref('发送验证码')
const getSms = () => {
  loginForm.value.validate('mobile').then((valid) => {
    if (!valid) {
      api
        .getSmsCodeApi({
          mobile: form.value.mobile,
          token: token.value,
          ExhCode: ExhCode.value
        })
        .then((res) => {
          if (res.code === 200) {
            downTime(60)
            showToast({
              message: '短信验证码已发送成功，请注意查收！',
              wordBreak: 'break-all',
              type: 'success',
              className: 'custom-toast'
            })
          }
        })
    }
  })
}
const getOpenID = () => {
  // 当前链接加获取时间
  const cUrl = window.location.href + '&time=' + Math.round(new Date() / 1000)
  if (isWeX.value) {
    if (cUrl.indexOf('openid') === -1) {
      if (cUrl.indexOf('InviteType') !== -1) {
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}&InviteType=eg`
      } else {
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}`
      }
    } else {
      // 如果有openid
      store.commit('setOpenID', route.query.openid)
      // 根据openid判断是否注册
      if (openid.value) {
        // checkOpenid()
      } else {
        router.go(0)
      }
    }
  }
}
const checkOpenid = () => {
  api
    .checkIdentityLoginApi({
      openid: openid.value,
      ExhCode: ExhCode.value,
      aliID: ''
    })
    .then((res) => {
      if (res.code === 200) {
        if (res.data) {
          store.commit('setVisitorID', res.data.visitorID)
          sessionStorage.setItem('invitesource', '1')
          sessionStorage.setItem('invitesourceID', res.data.visitorID)
          if (gconfig.value.SuccessPageVersion === 'V2') {
            router.push({ path: '/successV2' })
          } else {
            router.push({ path: '/success' })
          }
        }
      }
    })
}
</script>
<style lang="less">
@import '../../assets/login.less';
@import '../../assets/login-pc.less';
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f5f5f5;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .loading-img {
    width: 120px !important;
    height: 120px !important;
    object-fit: contain;
  }
}
.login-page {
  height: 100vh;
  background-image: url('~@/assets/bg.png');
  background-size: 100% 100%;
  background-position: top center;
  background-repeat: no-repeat;
  overflow: hidden;
}
.login-btns {
  padding: 6vw 4vw;
  display: flex;
  flex-wrap: wrap;
  gap: 2vw;
  .btn-double {
    img {
      width: auto;
      height: 10vw;
      display: block;
      margin-left: 9vw;
    }
  }
  .big-btn {
    box-sizing: border-box;
    img {
      height: 18vw;
      width: auto;
      display: block;
    }
  }
  .big-btnqn {
    box-sizing: border-box;
    img {
      width: 50%;
      display: block;
      margin-left: 9vw;
    }
    &.fullqn {
      
      width: 100%;
      margin: 0 auto;
    }
  }
  .two-col-row {
    margin-top:4vw;
    display: flex;
  }
  .btn-visitor {
    img {
      margin-left: 9vw;
      height: 14vw;
      width: auto;
    }
  }
  .btn-richeng {
    img {
      margin-left: 20vw;
      height: 14vw;
      width: auto;
    }
  }
  .btn-gw {
    img {
      margin-left: 9vw;
      height: 14vw;
      width: auto;
    }
  }
  .btn-hezuo {
    img {
      margin-left: 27vw;
      height: 14vw;
      width: auto;
    }
  }
  .three-col-row {
    width: 86%;
    margin: 4vw auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2vw 0;
    .col-item {
      flex: 1;
      text-align: center;
      img {
        height: 8vw;
        width: auto;
        display: inline-block;
      }
    }
    .separator {
      width: 1px;
      height: 12vw;
      flex-shrink: 0;
      margin: 0 4vw;
    }
  }
  .btn-link {
    width: 100%;
    img {
      width: 80%;
      display: block;
      margin-left: 9vw;
    }
  }
}
.minDia {
  position: fixed;
  top: 25vh;
  left: 0;
  right: 0;
  bottom: 0vh;
  background-image: url('~@/assets/zzbg.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 999;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .diaCon {
    width: calc(100vw - 2rem);
    background-color: #fff;
    border-radius: 1rem;
    max-height: 90vh;
    overflow-y: scroll;
    margin-left: 1rem;
    .tipTxt {
      padding: 8vw 4vw 2vw;
      p {
        font-size: 14px;
        line-height: 20px;
        text-align: left;
        padding-bottom: 3vw;
      }
    }
    .tipBtn {
      padding: 3vw 0;
      text-align: center;
      border-top: 1px solid #e1e1e1;
      .van-button {
        width: 40vw;
      }
    }
  }
}
.closeTxt {
  padding-top: 100px;
}
.login {
  position: relative;
  .enBox {
    text-align: right;
    padding: 0 3vw;
  }
  .tabs {
    border-bottom: 1px solid #fff;
    width: 90%;
    margin: 0 auto 6px;
    display: flex;
    span {
      display: inline-block;
      flex: 1;
      text-align: center;
      padding: 10px 0;
    }
    .active {
      background: rgba(255, 255, 255, 0.6);
      border-radius: 4px 4px 0 0;
      border-bottom: 2px solid #1989fa;
    }
  }
  .logins {
    position: relative;
    padding: 30px 10px 0;
    width: 90%;
    border: 1px solid #8dc7ff;
    margin: 0 auto;
    border-radius: 10px;
    background: #fff;
    .closeRegMobile {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 70px;
      height: auto;
      cursor: pointer;
    }
    .loginTit {
      font-size: 5vw;
      padding-bottom: 2vw;
      .loginTit-en {
        font-size: 3.0vw;
        font-weight: normal;
        color: #7a7979;
      }
    }
  }
  .loginFormbox {
    .label-en {
      font-size: 3vw;
      color: #7a7979;
      margin-left: 1vw;
    }
    .btn-en {
      font-size: 2.5vw;
      display: block;
    }
    .van-field__button {
      padding-left: 0;
    }
    .van-button--plain.van-button--primary {
      height: 40px;
      border: 0;
      border-left: 1px solid #666 !important;
      border-radius: 0;
    }
  }
  .exhName {
    padding: 0 12px 30px;
    line-height: 30px;
  }
  .btnbox {
    padding: 60px 18px 0px;
    .van-button {
      width: 100%;
    }
  }
  .pad40 {
    padding-bottom: 40px;
  }
}
</style>

<style lang="less">
/* Toast 全局样式 */
.custom-toast {
  min-width: 200px;
  max-width: 80%;
  padding: 20px 24px;
  font-size: 16px;
}
</style>
